<template>
    <div class="OTfacetsgroup OTfacetsgroupDashboard">
        <div :id="'status-facets-' + facetId" class="OTfacetcontainer"><h4 class="OTfacetTitle">{{ facet.label }}</h4>
            <div v-if="facet.dimensions.length > 0" class="OTmultipleSelectionSearch">
            
                <MultiFacetContainer
                    :facetId="facetId"
                    :facet="facet"
                    v-model="selectedFacets"
                    v-if="facet.cardinality === 'MULTI'">
                </MultiFacetContainer>

                <SingleFacetContainer
                    :facet="facet"
                    v-model="selectedFacets"
                    v-else>
                </SingleFacetContainer>

            </div>
            <ul v-else>
                <li class="facet OTfacet">
                    <div class="fieldContainer form-group OTformgroupsingle">
                        <label class="OTradio pl-2">No filters available</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

import {slugify} from '../../utils.js';
import SingleFacetContainer from './SingleFacetContainer.vue';
import MultiFacetContainer from './MultiFacetContainer.vue';

export default {
    props: ['facetId'],

    data() {
        return {
            'selectedFacets': []
        }
    },

    components: {
        SingleFacetContainer,
        MultiFacetContainer
    },

    created() {
        this.$eventBus.$on('clearAllFilters', this.clearAllSelectedFacets);     
    },

    computed: {
        facet() {
            return this.$store.state.facets.facets[this.facetId];
        },
    },

    methods: {
        slugify(val) {
            return slugify(val);
        },

        clearAllSelectedFacets() {
            if(!(this.facetId === "TF_ID"))
                this.selectedFacets = [];
        }
    },

    watch: {
        selectedFacets(newSelectedFacets) {
            var dimensions = newSelectedFacets.dimensions.map((selectedFacet) => {
                return selectedFacet;
            });

            this.$store.commit('facets/SET_SELECTED_FACETS', {
                id: this.facetId,
                dimensions: dimensions
            });

            this.$emit('selectedFacets', {
                facetId: this.facetId,
                dimensions: dimensions,
                fromDateinMillis: newSelectedFacets.fromDateinMillis,
                toDateinMillis: newSelectedFacets.toDateinMillis
            });
        }
    },

    beforeDestroy() {
        
    },
}

</script>
